import Lightbox from './Lightbox'

export default Lightbox

export * from './types'
